module.exports = __webpack_public_path__ + "static/servico3-97443af422f3163b33171fc4f873c27a.jpg";